import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { Box, Divider, IconButton, Typography } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import * as styles from './Filters.styles';
import FiltersDrawer from './FiltersDrawer';
import TrailerFilters from './TrailerFilters';
import LocationFilters from './LocationFilters';

const TrailerStatusFiltersDrawer = ({
  onClose,
  open,
  setCardsFilters,
  cardsFilters,
  onResetFilters,
}) => {
  const { viewBy } = useParams();

  const filtersProps = { cardsFilters, onResetFilters, setCardsFilters };

  return (
    <FiltersDrawer onClose={onClose} open={open}>
      <Box sx={styles.mobileHeader}>
        <Typography sx={styles.mobileTitle} variant="h5">
          Filters
        </Typography>
        <IconButton onClick={onClose} size="large" sx={styles.cancelButton}>
          <CloseRoundedIcon />
        </IconButton>
      </Box>
      <Divider sx={styles.mobileDividerDown} />
      <Box sx={styles.mobilePadding}>
        {viewBy === 'trailer' ? (
          <TrailerFilters {...filtersProps} />
        ) : (
          <LocationFilters {...filtersProps} />
        )}
      </Box>
    </FiltersDrawer>
  );
};
TrailerStatusFiltersDrawer.propTypes = {
  cardsFilters: PropTypes.shape({}).isRequired,
  onClose: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  setCardsFilters: PropTypes.func.isRequired,
};
TrailerStatusFiltersDrawer.defaultProps = {};

export default TrailerStatusFiltersDrawer;
